import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Gummies = () => {
    const rawHtml = `
        <style>
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
        </style>
        <div id="wrapper">
            <Header />
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <h2 class="display-3 fw-bold color all-ts">Gummies <span class="underliner nocolor viewport-detect" data-delay="1000">Supplements</span></h2>
                            <p>Discover our delicious and effective range of gummies for wellness and nutrition.</p>
                            <a href="#gummies-products" class="button py-3 px-4 bg-color-2 color h-bg-color h-text-light rounded mx-0">View Gummies<i class="bi-arrow-right ms-2 me-0"></i></a>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Gummies" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Gummies" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Gummies" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="content">
                <div class="content-wrap py-0">
                    <div id="gummies-products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Our Gummies Range</h2>
                                    <p>Explore our wide variety of functional gummies for all ages and needs.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- APPLE CIDER VINEGAR GUMMIES -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#apple-cider-vinegar">
                                                    <i class="bi bi-cup-straw me-2"></i>Apple Cider Vinegar Gummies
                                                </button>
                                            </h2>
                                            <div id="apple-cider-vinegar" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th colSpan="2">SUPPLEMENT FACT</th></tr>
                                                                <tr><th>INGREDIENTS</th><th>AMOUNT PER SERVING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Serving Size</td><td>1 Gummy</td></tr>
                                                                <tr><td>Servings Per Container</td><td>30 Gummies</td></tr>
                                                                <tr><td>Apple Cider Vinegar (5% Acetic Acid)</td><td>500 mg</td></tr>
                                                                <tr><td>Organic Beet root</td><td>40 mcg</td></tr>
                                                                <tr><td>Organic Pomegranate</td><td>40 mcg</td></tr>
                                                                <tr><td>Vitamin B9 (Folic Acid)</td><td>200 mcg DFE</td></tr>
                                                                <tr><td>Folic Acid</td><td>120 mcg</td></tr>
                                                                <tr><td>Vitamin B12 (Cyanocobalamin)</td><td>1.2 mcg</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- APPLE CIDER VINEGAR WITH CHARCOAL GUMMIES -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#apple-cider-charcoal">
                                                    <i class="bi bi-cup-straw me-2"></i>Apple Cider Vinegar with Charcoal Gummies
                                                </button>
                                            </h2>
                                            <div id="apple-cider-charcoal" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th colSpan="2">SUPPLEMENT FACT</th></tr>
                                                                <tr><th>INGREDIENTS</th><th>AMOUNT PER SERVING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Serving Size</td><td>1 Gummy</td></tr>
                                                                <tr><td>Servings Per Container</td><td>30 Gummies</td></tr>
                                                                <tr><td>Apple Cider Vinegar (5% Acetic Acid)</td><td>450 mg</td></tr>
                                                                <tr><td>Activated Charcoal</td><td>50 mg</td></tr>
                                                                <tr><td>Vitamin B9 (Folic Acid)</td><td>200 mcg DFE</td></tr>
                                                                <tr><td>Folic Acid</td><td>120 mcg</td></tr>
                                                                <tr><td>Vitamin B12 (Cyanocobalamin)</td><td>1.2 mcg</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- HAIR SKIN NAILS WITH BIOTIN GUMMIES -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#hair-skin-nails">
                                                    <i class="bi bi-droplet-half me-2"></i>Hair Skin Nails with Biotin Gummies
                                                </button>
                                            </h2>
                                            <div id="hair-skin-nails" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th colSpan="2">NUTRITIONAL FACTS</th></tr>
                                                                <tr><th>INGREDIENTS</th><th>AMOUNT PER SERVING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Serving Size</td><td>2 Gummies</td></tr>
                                                                <tr><td>Servings Per Container</td><td>30 Gummies</td></tr>
                                                                <tr><td>Vitamin A</td><td>2000 IU</td></tr>
                                                                <tr><td>Vitamin C</td><td>30 mg</td></tr>
                                                                <tr><td>Vitamin E</td><td>7 mg</td></tr>
                                                                <tr><td>Vitamin B6</td><td>1 mg</td></tr>
                                                                <tr><td>Folic Acid</td><td>200 mcg</td></tr>
                                                                <tr><td>Vitamin B12</td><td>1 mcg</td></tr>
                                                                <tr><td>Biotin</td><td>30 mcg</td></tr>
                                                                <tr><td>Vitamin B5</td><td>5.2 mg</td></tr>
                                                                <tr><td>Iodin</td><td>42 mcg</td></tr>
                                                                <tr><td>Zinc</td><td>2.5 mg</td></tr>
                                                                <tr><td>Inositol</td><td>20 mcg</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- HAIR SKIN NAILS ADVANCED GUMMIES -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#hair-skin-nails-adv">
                                                    <i class="bi bi-droplet-half me-2"></i>Hair Skin Nails Advanced Gummies
                                                </button>
                                            </h2>
                                            <div id="hair-skin-nails-adv" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th colSpan="2">NUTRITIONAL FACTS</th></tr>
                                                                <tr><th>INGREDIENTS</th><th>AMOUNT PER SERVING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Serving Size</td><td>2 Gummies</td></tr>
                                                                <tr><td>Servings Per Container</td><td>30 Gummies</td></tr>
                                                                <tr><td>Vitamin A</td><td>2000 IU</td></tr>
                                                                <tr><td>Vitamin C</td><td>30 mg</td></tr>
                                                                <tr><td>Vitamin E</td><td>7 mg</td></tr>
                                                                <tr><td>Vitamin B6</td><td>2 mg</td></tr>
                                                                <tr><td>Folic Acid</td><td>200 mcg</td></tr>
                                                                <tr><td>Vitamin B12</td><td>1.2 mcg</td></tr>
                                                                <tr><td>Biotin</td><td>40 mcg</td></tr>
                                                                <tr><td>Vitamin B5</td><td>5.2 mg</td></tr>
                                                                <tr><td>Iodin</td><td>50 mcg</td></tr>
                                                                <tr><td>Zinc</td><td>3 mg</td></tr>
                                                                <tr><td>Inositol</td><td>20 mcg</td></tr>
                                                                <tr><td>Hyluronic Acid</td><td>250 mcg</td></tr>
                                                                <tr><td>Grape seed Extract</td><td>100 mcg</td></tr>
                                                                <tr><td>Amla extract</td><td>200 mcg</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- MELATONIN GUMMIES -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#melatonin">
                                                    <i class="bi bi-moon-stars me-2"></i>Melatonin Gummies
                                                </button>
                                            </h2>
                                            <div id="melatonin" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr><th colSpan="2">NUTRITIONAL INFORMATION</th></tr>
                                                                <tr><th>INGREDIENTS</th><th>AMOUNT PER SERVING</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Serving Size</td><td>1 Gummy</td></tr>
                                                                <tr><td>Servings Per Container</td><td>30 Gummies</td></tr>
                                                                <tr><td>Melatonin</td><td>5 mg</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    `;
    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default Gummies; 